import { DatePipe } from '@angular/common';
import { environment } from 'projects/environments/environment';

export { };
String.prototype.ToDateTimeString = function (this: string): string {
    if (this) {
        const datePipe = new DatePipe(environment.Culture);
        return datePipe.transform(this, environment.DateTimeFormat);
    } else {
        return '';
    }
};

String.prototype.ToDateString = function (this: string): string {
    if (this) {
        const datePipe = new DatePipe(environment.Culture);
        return datePipe.transform(this, environment.DateFormat);
    } else {
        return '';
    }
};